module.exports = __webpack_public_path__ + "media/images/city/029-castel-sant-angelo-81105b93b16d6b0ea3ae4e57784c9bbb.svg";